import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_REPORTS_FILTERS } from './constants';

export const getReportsFilters = extendRoutine(createRoutine(GET_REPORTS_FILTERS), 'RESET');
